import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';

// Pages
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import Settings from './pages/Settings';
import WebScraping from './pages/WebScraping';
import Platforms from './pages/Platforms';
import Categories from './pages/Categories';
import ItemGroups from './pages/ItemGroups';
import GstRates from './pages/GstRates';
import GstReport from './pages/GstReport';
import Vendors from './pages/Vendors';
import Customers from './pages/Customers';
import Purchases from './pages/Purchases';
import Orders from './pages/Orders';
import Returns from './pages/Returns';
import Users from './pages/Users';
import Inventory from './pages/Inventory';
import Reports from './pages/Reports';
import ProfitLoss from './pages/ProfitLoss';
import ExportImport from './pages/ExportImport';
import Shipping from './pages/Shipping';
import Notifications from './pages/Notifications';
import NotFound from './pages/NotFound';

// Layout
import Layout from './components/Layout/Layout';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900">
        <div className="text-2xl font-semibold text-gray-700 dark:text-gray-300">Loading...</div>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

function AppRouter() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />

      {/* Protected Routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="categories" element={<Categories />} />
        <Route path="item-groups" element={<ItemGroups />} />
        <Route path="gst" element={<GstRates />} />
        <Route path="gst-report" element={<GstReport />} />
        <Route path="vendors" element={<Vendors />} />
        <Route path="customers" element={<Customers />} />
        <Route path="purchases" element={<Purchases />} />
        <Route path="products" element={<Products />} />
        <Route path="orders" element={<Orders />} />
        <Route path="returns" element={<Returns />} />
        <Route path="inventory" element={<Inventory />} />
        <Route path="reports" element={<Reports />} />
        <Route path="profit-loss" element={<ProfitLoss />} />
        <Route path="tools" element={<ExportImport />} />
        <Route path="shipping" element={<Shipping />} />
        <Route path="platforms" element={<Platforms />} />
        <Route path="scraping" element={<WebScraping />} />
        <Route path="notifications" element={<Notifications />} />
        <Route path="users" element={<Users />} />
        <Route path="settings" element={<Settings />} />
      </Route>

      {/* 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default AppRouter;
